import { CancelOutlined, Phone } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

export default function PGMemberSearchForm(props) {
  const { t } = useTranslation();
  const NAME = "NAME";
  const LAST8VIN = "LAST8VIN";
  const PHONE = "PHONE";

  const formRef = useRef();
  const [last8Vin, setLast8Vin] = useState(props.currState?.MemberLookup.last8Vin || props.currState.last8Vin || "");
  const [firstName, setFirstName] = useState(
    props.currState?.MemberLookup.firstName || props.currState.FirstName || "",
  );
  const [lastName, setLastName] = useState(props.currState?.MemberLookup.lastName || props.currState.LastName || "");
  const [phone, setPhone] = useState(props.currState?.MemberLookup?.phone || props.currState.Number || "");
  const [lessThanEightVin, setLessThanEightVin] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: NAME, value: t("description.Name") },
    { key: PHONE, value: t("description.ConfirmCustomerPhoneNumber") },
    { key: LAST8VIN, value: t("description.ConfirmCustomerLast8VIN1") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState(props.currState.MemberLookup?.searchType || NAME);

  useEffect(() => {
    devLog(selectedSearchTypes);
    setFirstName(firstName);
    setLastName(lastName);
    setPhone(phone);
    setLast8Vin(last8Vin);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (last8Vin.length < 8 && selectedSearchTypes === "LAST8VIN") {
      setLessThanEightVin(true);
      return;
    }
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*FirstName*/}
          {selectedSearchTypes === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerFirstName")}:</div>
                <input
                  type="string"
                  placeholder="ex: JOHN"
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    // setLessThanEightVin(false);
                    setFirstName(e.target.value?.trim().toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*LastName*/}
          {selectedSearchTypes === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerLastName")}:</div>
                <input
                  type="string"
                  placeholder="ex: DOE"
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    // setLessThanEightVin(false);
                    setLastName(e.target.value?.trim().toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*LAST 8 VIN*/}
          {selectedSearchTypes === LAST8VIN && (
            <>
              <div className="group-1">
                <div className="label">{t("description.DropdownOptions1")}:</div>
                <input
                  type="string"
                  placeholder={t("description.DropdownOptions1")}
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  onChange={(e) => {
                    vinInputLength(e);
                    setLast8Vin(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
              {lessThanEightVin && <Alert severity="error">{t("description.VinInputLessErrorMsg")}</Alert>}
            </>
          )}

          {/*Phone*/}
          {selectedSearchTypes === PHONE && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerPhoneNumber")}:</div>
                <input
                  type="number"
                  placeholder="ex: 1234567890"
                  name="phone"
                  className="input form-control required"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
